import { machineTechniciansRouteStore } from '../domain/store';
import { machineTechnicianUpsertModalRouteStore } from '../domain/upsert-modal-store';

export default () => {
  machineTechnicianUpsertModalRouteStore.setInitialState();
  machineTechniciansRouteStore.setValue('activeTechnicianId', null);
  machineTechniciansRouteStore.setValue('showingUpsertModal', false);
};
